// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomNavbarItem_wrapper__f6oOu","active":"BottomNavbarItem_active__WbccM","badge":"BottomNavbarItem_badge__TqnAW","pulse":"BottomNavbarItem_pulse__pvqZq"};